import React from 'react';

import './styles.css';

const TextSmall = ({ children }) => {
  return <span className="TextSmall">{children}</span>;
};

export default TextSmall;
